const startingStyle = "data-starting-style";
const endingStyle = "data-ending-style";
export {
  endingStyle,
  startingStyle
};
//# sourceMappingURL=TransitionStatusDataAttributes.js.map
